import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'vocabfilter'
})
export class FilterPipe implements PipeTransform {

  transform(items: any[], searchText: string): any[] {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }
    searchText = searchText.toLowerCase();
    return items.filter(item => {
      return item.vocabName.toLowerCase().includes(searchText);
    });
  }

}
